export default __webpack_public_path__ + "static/button-and-icon-78c260837c00b1cc5cce80e3eef2f5fedc120344f23422ef0de247f153d967e9.png";